import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ManageAccountService } from '../services/api-lab4u/user-auth/manage-account.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { LanguageService } from '../services/language/language.service';
import { TranslocoDirective } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';

declare function init_plugins(): void;
@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.css'],
  imports: [
    TranslocoDirective,
    RouterLink,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    MatCheckbox,
  ],
})
export class DeleteAccountComponent implements OnInit {
  deleteAccountForm!: FormGroup;

  checkboxStatus = false;
  errorFlag = false;
  errorCode = 0;

  accountInfo: { email: string; language: string } = {
    email: '',
    language: '',
  };
  submitted = false;
  language!: string;

  constructor(
    private manageAccountService: ManageAccountService,
    private languageService: LanguageService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
  ) {}
  ngOnInit() {
    init_plugins();
    this.language = this.languageService.getLanguage();
    this.deleteAccountForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      checkboxStatus: [false, Validators.requiredTrue],
    });
  }

  buttonStatus(): boolean {
    return this.deleteAccountForm.valid;
  }

  isInvalidEmail(): boolean {
    const control = this.deleteAccountForm.get('email');
    return !!control && control.invalid && (control.dirty || control.touched);
  }

  sendAccountDataDeletionRequest() {
    this.accountInfo.email = this.deleteAccountForm.get('email')?.value ?? '';
    this.manageAccountService
      .accountDataDeletionRequest(this.accountInfo)
      .subscribe({
        next: (_data) => {
          this.submitted = true;
          this.cdr.markForCheck();
        },
        error: (error) => {
          this.errorFlag = true;
          this.errorCode = error.status;
          this.cdr.markForCheck();
        },
      });
  }

  /**
   * Function to change language localStorage
   * @param language Variable to save the actual language
   */
  changeLanguage(language: string) {
    if (language === 'es' || language === 'en') {
      this.language = language;
      this.languageService.applyLanguage(this.language);
      window.location.reload();
    } else {
      return;
    }
  }
}
